import { useMutation } from "react-query";
import http from "infra/http";

function useCancelarAcordo(id: string) {
  return useMutation(
    () => {
      return http.delete(`/v1/acordo/${id}`);
    },
    { retry: false }
  );
}

export default useCancelarAcordo;
